export enum TabTypes {
	PlainCalendar,
	PriceGraph,
	RoundtripMatrix
}
